// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3t4iU","item":"styles_item__Gc9Ii"};